import { render, staticRenderFns } from "./NumberOfOrdersPage.vue?vue&type=template&id=1efbe2e8&scoped=true"
import script from "./NumberOfOrdersPage.vue?vue&type=script&lang=js"
export * from "./NumberOfOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./NumberOfOrdersPage.vue?vue&type=style&index=0&id=1efbe2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efbe2e8",
  null
  
)

export default component.exports